import { FormControl, InputLabel } from '@material-ui/core';
import React from 'react';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import Tooltip from 'retired/Tooltip';
import { lightGray } from 'utils/color-styles';

interface TotalLimitLabelProps {
  summary?: boolean;
}

/**
 * @NOTE-DP: This component is a pretty odd abstraction.
 * Due to the fact that we're using MUI's `InputLabel` for labels, we're in a big mess of a situation: this component does `transform:scale(0.75)` on its content, so we need to a apply a bunch of hacks
 */
export const TotalLimitLabel = ({ summary }: TotalLimitLabelProps): JSX.Element => {
  const showBadge = useMediaQuery(`(min-width:${summary ? 1250 : 960}px)`);
  return (
    <FormControl
      style={{
        width: '100%',
        height: 17,
        // @NOTE-DP: we need to offset the component back up, because of the changed component's height
        marginTop: showBadge ? -5 : 0,
      }}
    >
      {/* @NOTE-DP: we're setting the width of this component to stretch to its full parent's width, accounting for `transform`: 100%/0.75=133% */}
      <InputLabel shrink style={{ width: '133%' }}>
        <Tooltip title="Additional fees are not included within the Budget &amp; Rules page, to avoid going over limit please be aware of these additional fees.">
          <span>
            Total Limit{' '}
            {showBadge ? (
              <div
                style={{
                  display: 'inline-block',
                  border: `1px solid ${lightGray}`,
                  borderRadius: 20,
                  padding: '3px 10px',
                  fontSize: 14,
                  marginLeft: 5,
                  textTransform: 'initial',
                }}
              >
                Fees not included <InfoIcon />
              </div>
            ) : (
              <InfoIcon />
            )}
          </span>
        </Tooltip>
      </InputLabel>
    </FormControl>
  );
};
